export enum QACaseType {
  ENGINE_RULES_REVIEW = 'engine_rules_review',
  AUTO_PIA_RULES_REVIEW = 'auto_pia_rules_review',
}

export enum QACaseStatus {
  IN_QA = 'in_qa',
  COMPLETED_QA = 'completed_qa',
}

export enum QATriggerSource {
  WB_MANUAL = 'wb_manual',
  SCHEDULED_JOB = 'scheduled_job',
}

export enum QAOutcome {
  ACCURATE = 'accurate',
  INACCURATE_RULES = 'inaccurate_rules',
  INACCURATE_UW_PHILOSOPHY = 'inaccurate_uw_philosophy',
  INACCURATE_RULES_AND_UW_PHILOSOPHY = 'inaccurate_rules_and_uw_philosophy',
  MISSING_RULES_RULESETS = 'missing_rules_rulesets',
  INELIGIBLE = 'ineligible',
}

// User interface for assignedTo field
export interface QACaseUser {
  id: number;
  name: string;
  [key: string]: any;
}

export interface QACaseApplication {
  // TODO: Typed this with what frontend uses for application
  applicationInfo: {
    [key: string]: any;
  };
  [key: string]: any;
}

export interface QAFindingResponseDto {
  id?: number;
  qaCaseId?: number;
  rulesetName?: string;
  taxonomy?: string;
  evidenceSource?: string;
  supposedRating?: string;
  comments?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
}

// Frontend DTO types for forms and updates
export interface QAFindingDto {
  rulesetName?: string;
  taxonomy?: string;
  evidenceSource?: string;
  supposedRating?: string;
  comments?: string;
}

export interface UpdateQACaseDto {
  status?: QACaseStatus;
  reason?: string;
  assignedTo?: number;
  outcome?: QAOutcome;
  findings?: QAFindingDto[];
  supposedRating?: string;
}

// Form interface for validation
export interface QACaseForm {
  outcome: QAOutcome;
  supposedRating?: string;
  findings?: QAFindingDto[];
}

// List item (no findings on list response)
export interface QACaseResponseDto {
  id: number;
  policyId: number;
  caseType: QACaseType;
  application: QACaseApplication | null;
  status: QACaseStatus;
  reason: string | null;
  triggerSource: QATriggerSource;
  assignedTo: QACaseUser | null;
  outcome: QAOutcome | null;
  supposedRating: string | null;
  createdAt: string | Date;
  updatedAt: string | Date;
  sla: Date | null;
  product: {
    id: number;
    type: string;
    name: string;
    order: number;
    displayText: string;
  };
  findings: QAFindingResponseDto[];
}

// Detail includes findings

export interface QACaseListResponse {
  data: QACaseResponseDto[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPrevPage: boolean;
  };
}
